import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import { useInterval } from 'react-use';
import styles from './style.module.scss';

const handleDragStart = (e) => {
  e.preventDefault();
};

/**
 * 自定义 IM 入口
 * 需要自定义初始化位置 position:fixed
 * ReactDraggable 需要设置 onMouseDown onMouseUp style className
 *
 * todo
 * [ ] newMessage
 * [ ] online offline
 *
 * @returns {any}
 * @constructor
 */
const ImSuspension = (props) => {
  const overflowStatus = props.newMessageCount > 99;
  const [popping, setPopping] = useState(false);

  useInterval(() => {
    if (!props.opening && props.newMessageCount) {
      setPopping(true);
      // remove 动画 class
      setTimeout(() => {
        setPopping(false);
      }, 2000);
    }
  }, 10000);

  return (
    <div
      className={cls(
        styles.dragWrapper,
        styles.imPosition,
        props.className,
        {
          [styles.hidden]: props.opening,
        }
      )}
      style={{
        ...props.style,
        cursor: props.dragMoving ? 'move' : 'pointer',
      }}
    >
      <div
        className={cls(
          styles.container,
          'im-suspension',
          {
            [styles.popping]: popping,
          },
        )}
        onClick={props.onClick}
        onTouchEnd={props.onClick}
        onMouseDown={props.onMouseDown}
        onMouseUp={props.onMouseUp}
      >
        <div className={styles.avatar}>
          <img
            onDragStart={handleDragStart}
            src={props.avatar || 'https://m.xiguacity.cn/gutenberg/image/im-shawn-2.png'}
            alt=""
          />
        </div>
        <div className={styles.text}>联系老师</div>
        {
          props.newMessageCount ? (
            <div className={cls(styles.count, {
              [styles.overflowCount]: overflowStatus,
            })}
            >
              {
                overflowStatus ? '99+' : props.newMessageCount
              }
            </div>
          ) : null
        }
      </div>
    </div>
  );
};

ImSuspension.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  newMessageCount: PropTypes.number,
  style: PropTypes.object,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  dragMoving: PropTypes.bool,
  opening: PropTypes.bool,
  avatar: PropTypes.string,
};


export default ImSuspension;
